module.exports = __webpack_public_path__ + "img/collection-select.bbc2ab66.svg";